/* ============================================================
   DND — Shopify commerce bridge
   Loads AFTER dnd-data.js, BEFORE dnd-app.js.
   - Syncs displayed prices from real Shopify variants (when present)
   - Implements window.dndCheckout(): clear cart -> add lines -> /checkout
   window.DND_SHOPIFY is injected by sections/dnd-home.liquid from live
   Shopify product data. When products don't exist yet, everything falls
   back gracefully to the design's static prices and a preview note.
   ============================================================ */
(function () {
  var S = window.DND_SHOPIFY || (window.DND_SHOPIFY = {});
  S.variants = S.variants || {};   // { still: {8:id,12:id,24:id}, ... }
  S.prices = S.prices || {};       // { still: {8:790,12:1130,24:2140}, ... }  (major units)
  S.sellingPlans = S.sellingPlans || {}; // { still: planId, ... } optional subscription plans

  /* Normalize the per-product map injected by the Liquid section
     ( S.products = { still: { variants, prices, plan }, ... } ) into the
     flat lookups the rest of this file uses. */
  if (S.products) {
    Object.keys(S.products).forEach(function (pid) {
      var entry = S.products[pid] || {};
      if (entry.variants) S.variants[pid] = entry.variants;
      if (entry.prices) S.prices[pid] = entry.prices;
      if (entry.plan) S.sellingPlans[pid] = entry.plan;
    });
  }

  /* ---- 1. price sync: override design pack prices with live Shopify prices ---- */
  try {
    var products = (window.DND && window.DND.products) || [];
    products.forEach(function (p) {
      var pr = S.prices[p.id];
      if (!pr) return;
      (p.packs || []).forEach(function (pk) {
        var live = pr[pk.size] != null ? pr[pk.size] : pr[String(pk.size)];
        if (live != null) pk.price = live;
      });
      var twelve = pr[12] != null ? pr[12] : pr['12'];
      if (twelve != null) { p.price = twelve; p.perCan = Math.round(twelve / 12); }
    });
  } catch (e) { /* keep static prices */ }

  /* ---- 2. real checkout ---- */
  function resolveVariant(pid, size) {
    var v = S.variants[pid];
    if (!v) return null;
    return v[size] != null ? v[size] : v[String(size)];
  }

  window.dndCheckout = function (items, plan, setNote) {
    var lines = [];
    Object.keys(items || {}).forEach(function (key) {
      var parts = key.split(':');
      var pid = parts[0], size = parts[1], qty = items[key];
      var vid = resolveVariant(pid, size);
      if (!vid || qty <= 0) return;
      var line = { id: vid, quantity: qty };
      if (plan === 'sub' && S.sellingPlans[pid]) line.selling_plan = S.sellingPlans[pid];
      lines.push(line);
    });

    /* No live variants mapped yet -> keep the design's preview behaviour */
    if (!lines.length) {
      if (typeof setNote === 'function') { setNote(true); setTimeout(function () { setNote(false); }, 2600); }
      if (window.console) console.warn('[DND] No Shopify variants mapped. See theme SETUP — create the 3 products with 8/12/24 pack variants.');
      return;
    }

    var clearUrl = S.cartClear || '/cart/clear.js';
    var addUrl = S.cartAdd || '/cart/add.js';
    var checkoutUrl = S.checkoutUrl || '/checkout';

    fetch(clearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lines })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (window.console) console.error('[DND] cart/add failed', res.j);
          if (typeof setNote === 'function') { setNote(true); setTimeout(function () { setNote(false); }, 3000); }
          return;
        }
        window.location.href = checkoutUrl;
      })
      .catch(function (err) {
        if (window.console) console.error('[DND] checkout error', err);
        window.location.href = (S.cartUrl || '/cart');
      });
  };
})();
